module.exports = __webpack_public_path__ + "static/media/Logo.181c3102.svg";